import { state$ } from "../globalState";
import { TacheService } from "../../services/TacheService";
import { MembreTacheService } from "../../services/MembreTacheService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import { areFiltersDefault } from "../../helpers/filters";

export const tachesState = {
    async loadTaches() {
        if (state$.taches.list.get().length > 0 && areFiltersDefault(state$.taches.filters.get())) {
            return; // Already loaded and no filters
        }
        state$.taches.loading.set(true);
        try {
            const response = await TacheService.getInstance().search(state$.taches.filters.get());
            state$.taches.list.set(response.data.data);
            state$.taches.pagination.set(response.data);
        } catch (error) {
            catchError(error);
        } finally {
            state$.taches.loading.set(false);
        }
    },

    async refreshTaches() {
        state$.taches.loading.set(true);
        try {
            const response = await TacheService.getInstance().search(state$.taches.filters.get());
            state$.taches.list.set(response.data.data);
            state$.taches.pagination.set(response.data);
        } catch (error) {
            catchError(error);
        } finally {
            state$.taches.loading.set(false);
        }
    },

    async loadMoreTaches() {
        const pagination = state$.taches.pagination.get();
        // get taches loading state
        const loading = state$.taches.loading.get();
        if (pagination?.next_page_url && !loading) {
            state$.taches.loading.set(true);
            try {
                const response = await TacheService.post(pagination.next_page_url, state$.taches.filters.get());
                if (response) {
                    state$.taches.list.push(...response.data.data);
                    state$.taches.pagination.set(response.data);
                }
            } catch (error) {
                catchError(error);
            } finally {
                state$.taches.loading.set(false);
            }
        }
    },

    async getTache(uid) {
        let tache = state$.taches.list.get().find(t => t.uid === uid);
        if (!tache) {
            try {
                tache = await TacheService.getInstance().find(uid);
                state$.taches.list.push(tache.data);
            } catch (error) {
                catchError(error);
            }
        }
        // Fetch latest version in background
        TacheService.getInstance().find(uid).then(response => {
            this.updateTacheInList(response.data);
        }).catch(catchError);

        return tache;
    },

    updateTacheInList(updatedTache) {
        const list = state$.taches.list.get();
        const index = list.findIndex(t => t.uid === updatedTache.uid);
        if (index !== -1) {
            const newList = [...list];
            newList[index] = updatedTache;
            state$.taches.list.set(newList);
        } else {
            state$.taches.list.set([...list, updatedTache]);
        }
    },

    addTache(tache) {
        state$.taches.list.unshift(tache);
    },

    updateTache(uid, updatedData) {
        const index = state$.taches.list.get().findIndex(t => t.uid === uid);
        if (index !== -1) {
            state$.taches.list[index].set(updatedData);
        }
    },

    removeTacheFromList(uid) {
        const index = state$.taches.list.get().findIndex(t => t.uid === uid);
        if (index !== -1) {
            state$.taches.list.splice(index, 1);
        }
    },

    async deleteTache(uid) {
        state$.taches.loading.set(true);
        try {
            const response = await TacheService.getInstance().remove(uid);
            Toast.success(response.message);
            this.removeTacheFromList(uid);
            return response;
        } catch (error) {
            catchError(error);
            throw error;
        } finally {
            state$.taches.loading.set(false);
        }
    },

    async changeTacheStep(uid, stepId) {
        try {
            const response = await TacheService.getInstance().changeStep(uid, { statut_id: stepId });
            Toast.success(response.message);
            this.updateTacheInList(response.data);
        } catch (error) {
            catchError(error);
        }
    },

    async followTache(tacheId, userId) {
        try {
            await MembreTacheService.getInstance().create({ tache_id: tacheId, user_ids: [userId] });
            Toast.success("Vous suivez désormais cette tache.");
            const tache = await TacheService.getInstance().find(tacheId);
            this.updateTacheInList(tache.data);
        } catch (error) {
            catchError(error);
        }
    }
};
